<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <v-card title>
          <v-card-text>
            <DataTableMain
              :datatable="table"
              :on-success="successAction"
              :itemsAction="tableAction"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <EmpresaDialog v-if="get_dialogMain.dialog" :model="company" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import EmpresaDialog from '@/components/dialogs/EmpresaDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
          // ,{ title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData' }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Direccion', value: 'direccion', class: 'black--text' },
          { text: 'RFC', value: 'rfc', class: 'black--text' },
          { text: 'Correo', value: 'correo', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          // { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-2', action: 'toEditData', code: 'config.company-update' }
        ]
      },
      footer: {
        paging: true
      }
    },
    company: {}
  }),
  components: {
    DataTableMain,
    EmpresaDialog
  },
  mounted () {
    this.PostListObjects({ url: '/config/empresas' })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['PostListObjects']),

    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.PostListObjects({ url: '/config/empresas' })
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    toEditData (item) {
      this.company = item
      this.SHOW_DIALOG_MAIN({ type: 'update' })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_objects'])
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style></style>
